module.exports = __webpack_public_path__ + "static/EWY_Shar Simpson-b51df788d08a688ce8b5c58169dc3fe2.mp4";